(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7420],{

/***/ 91249:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mybalance",
      function () {
        return __webpack_require__(94925);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21110);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83466);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62077);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 450px;\n  @media screen and (max-width: 1024px) {\n    height: 400px;\n  }\n\n  @media screen and (min-width: 601px) and (max-width: 768px) {\n    width: 100%;\n    height: 300px;\n  }\n  @media screen and (max-width: 600px) {\n    width: 100%;\n    height: 400px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  width: 100%;\n  top: -280px;\n  z-index: -1;\n  height:100%;\n\n  @media screen and (min-width: 2000px) {\n    top: -380px;\n  }\n\n  @media screen and (max-width: 1440px) {\n    top: -270px;\n  }\n\n  @media screen and (max-width: 1336px) {\n    top: -315px;\n  }\n\n  @media screen and (max-width: 1024px) {\n    top: -280px;\n  }\n  @media screen and (max-width: 801px) {\n    top: -290px;\n  }\n  @media screen and (max-width: 600px) {\n    top: -150px;    \n  }\n  @media screen and (max-width: 500px) {\n    top: -65px;    \n  }\n  @media screen and (min-width: 2000px) {\n    top: -380px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media screen and (max-width: 600px) {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  @media screen and (max-width: 600px) {\n    display: block;\n    width: 100%;\n    position: absolute;\n  }\n  @media screen and (max-width: 600px) and (min-width: 401px) {\n    top: -80px;\n  }\n  @media screen and (max-width: 400px) and (min-width: 360px) {\n    top: -30px;\n  }\n  @media screen and (max-width: 360px){\n    top: 0px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0px 250px;\n  z-index: 99;\n  @media screen and (max-width: 1336px) {\n    padding: 0px 200px;\n  }\n  @media screen and (max-width: 1024px) {\n    padding: 0px 164px;\n  }\n  @media screen and (max-width: 768px) {\n    padding: 0px 100px;\n  }\n  @media screen and (max-width: 600px) {\n    padding: 0 50px;\n  }\n  @media screen and (max-width: 400px) {\n    padding: 0 32px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: 0px;\n  padding-top: 115px;\n  @media screen and (min-width: 2000px) {\n    padding-left: 200px;\n  }\n  @media screen and (max-width: 1440px) {\n    padding-top: 100px;\n  }\n  @media screen and (max-width: 1336px) {\n    padding-top: 70px;\n  }\n  @media screen and (max-width: 1024px) {\n    padding-top: 100px;\n  }\n  @media screen and (max-width: 920px) {\n    padding-top: 80px;\n  }\n  @media screen and (max-width: 768px) {\n  }\n  @media screen and (max-width: 600px) {\n    padding-top: 55px;\n    gap: 12px;\n  }\n  @media screen and (min-width: 2000px) {\n    padding-left: 200px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media screen and (max-width: 600px) {\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 12px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media screen and (max-width: 1440px) {\n    font-size: 90px;\n  }\n\n  @media screen and (max-width: 1024px) {\n    font-size: 60px;\n  }\n\n  @media screen and (max-width: 920px) {\n    font-size: 50px;\n  }\n  @media screen and (max-width: 600px) {\n    font-size: 48px;\n    font-weight: 700;\n    line-height: 60px;\n  }\n  @media screen and (max-width: 320px) {\n    font-size: 40px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: 158px;\n  top: 60px;\n  @media screen and (min-width: 2560px) {\n    right: 500px;\n    top: 100px;\n  }\n  @media screen and (min-width: 2000px) {\n    right: 500px;\n    top: 65px;\n  }\n  @media screen and (max-width: 1400px) {\n    right: 100px;\n    top: 24px;\n  }\n  @media screen and (max-width: 1024px) {\n    right: 140px;\n    top: 70px;\n  }\n  @media screen and (max-width: 920px) {\n    right: 88px;\n    top: 38px;\n  }\n  @media screen and (max-width: 768px) {\n    top: 60px;\n    right: 48px;\n  }\n  @media screen and (max-width: 600px) {\n    top: 90px;\n    right: 48px;\n  }\n  @media screen and (max-width: 500px) {\n    top: 187px;\n  }\n  @media screen and (max-width: 320px) {\n    top: 153px;\n    right: 31px;\n  }\n  @media screen and (min-width: 2560px) {\n    right: 500px;\n    top: 100px;\n  }\n  @media screen and (min-width: 2000px) {\n    right: 500px;\n    top: 65px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 627px;\n  @media screen and (max-width: 1336px) {\n    width: 555px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 450px;\n  }\n  @media screen and (max-width: 920px) {\n    width: 330px;\n  }\n  @media screen and (max-width: 600px) {\n    width: 231px;\n  }\n  @media screen and (max-width: 360px) {\n    width: 180px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}



var PageHeader = function(param) {
    var bgColor = param.bgColor, nameTitle = param.nameTitle, namePlace = param.namePlace, imgIcon = param.imgIcon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Bg, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsBgBanner, {
                        color: bgColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CsBgBannerMobile, {
                        color: bgColor
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Row, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Col, {
                        height: "100%",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FlexTitle, {
                            width: "100%",
                            height: "100%",
                            alignItems: "start",
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextTitle, {
                                    textTransform: "uppercase",
                                    color: "white",
                                    fontSize: "16px",
                                    bold: true,
                                    children: nameTitle
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextPlace, {
                                    fontSize: "96px",
                                    bold: true,
                                    color: "white",
                                    children: namePlace
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ColImage, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapImg, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImgIcon, {
                                src: imgIcon
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-99b22b7a-0"
})(_templateObject());
var Bg = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-99b22b7a-1"
})(_templateObject1());
var CsBgBanner = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-99b22b7a-2"
})(_templateObject2());
var CsBgBannerMobile = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-99b22b7a-3"
})(_templateObject3());
var Row = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-99b22b7a-4"
})(_templateObject4());
var Col = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-99b22b7a-5"
})(_templateObject5());
var FlexTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-99b22b7a-6"
})(_templateObject6());
var TextTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-99b22b7a-7"
})(_templateObject7());
var TextPlace = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-99b22b7a-8"
})(_templateObject8());
var ColImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-99b22b7a-9"
})(_templateObject9());
var WrapImg = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-99b22b7a-10"
})(_templateObject10());
var ImgIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-99b22b7a-11"
})(_templateObject11());


/***/ }),

/***/ 76688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(186);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83468);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n  transition: border-radius 0.15s;\n  color: #fdb533;\n  > svg {\n    fill: #fff !important;\n  }\n\n  @media screen and (max-width: 600px) {\n    padding: 0 10px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 180px;\n  height: 100%;\n  max-height:250px;\n  padding: 12px;\n  position: absolute;\n  overflow-y: hidden;\n  overflow-x:hidden;\n  z-index: ",
        ";\n  transition: transform 0.15s, opacity 0.15s;\n  transform: scaleY(0);\n  transform-origin: top;\n  opacity: 0;\n  box-sizing: border-box;\n  box-shadow: inset 0px -2px 4px rgba(255, 255, 255, 0.16), inset 4px 3px 3px rgba(0, 0, 0, 0.28);\n  border-radius: 10px;\n  background: ",
        ";\n  color: ",
        " !important;\n  ",
        " {\n    min-width: 50px;\n    width: 160px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " {\n        /* box-shadow: ",
        "; */\n      }\n\n      ",
        " {\n        height: auto;\n        transform: scaleY(1);\n        opacity: 1;\n        border-top-width: 0;\n        box-shadow: ",
        ";\n        width: 100%;\n        background: #ffffff;\n        top: 49px;\n        border-radius: 8px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: ",
        "px;\n  position: relative;\n  width: 220px;\n  height: 48px;\n  box-sizing: border-box;\n  @media only screen and (max-width: 600px) {\n    width: 160px;\n  }\n  ",
        " {\n    // border-right: 0.15px solid rgba(151, 151, 151, 0.69);\n  }\n\n  border: 2px solid #e6e8ec;\n  border-radius: 12px;\n\n  ",
        " {\n    min-width: 100px;\n  }\n\n  ",
        "\n\n  svg {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n    fill: #fdb533 !important;\n  }\n  @media only screen and (max-width: 600px) {\n    width: 100%;\n    margin-top:1rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  z-index: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  list-style: none;\n  padding: 8px 16px;\n  border-radius:6px;\n  &:hover {\n    background: #ff592c;\n    > div {\n      color: #fff !important;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media screen and (max-width: 320px) {\n    padding: 0px\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var DropDownHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7363816c-0"
})(_templateObject());
var DropDownListContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7363816c-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.isDark ? "#fdb533" : "#fff";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var DropDownContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7363816c-2"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), DropDownHeader, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    }, DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    });
});
var DropDownList = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-7363816c-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-7363816c-4"
})(_templateObject5());
var Select = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, _defaultOptionIndex = _param.defaultOptionIndex, defaultOptionIndex = _defaultOptionIndex === void 0 ? 0 : _defaultOptionIndex, placeHolderText = _param.placeHolderText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "options",
        "onOptionChange",
        "defaultOptionIndex",
        "placeHolderText"
    ]);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOptionIndex), selectedOptionIndex = ref2[0], setSelectedOptionIndex = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        width: 0,
        height: 0
    }), containerSize = ref3[0], setContainerSize = ref3[1];
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)().theme;
    var toggling = function(event) {
        if (options.length > 1) {
            setIsOpen(!isOpen);
        }
        event.stopPropagation();
    };
    var onOptionClicked = function(selectedIndex) {
        return function() {
            setSelectedOptionIndex(selectedIndex);
            setIsOpen(false);
            setOptionSelected(true);
            if (onOptionChange) {
                onOptionChange(options[selectedIndex]);
            }
        };
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setContainerSize({
            width: dropdownRef.current.offsetWidth,
            height: dropdownRef.current.offsetHeight
        });
        var handleClickOutside = function() {
            setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (defaultOptionIndex) {
            setSelectedOptionIndex(defaultOptionIndex - 1);
            setOptionSelected(true);
        }
    }, [
        defaultOptionIndex
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropDownContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        isOpen: isOpen
    }, props), {
        ref: containerRef
    }), containerSize), {
        children: [
            containerSize.width !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownHeader, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: !optionSelected && placeHolderText ? "text" : undefined,
                    children: !optionSelected && placeHolderText ? placeHolderText : options[selectedOptionIndex].label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                color: theme.isDark ? "#fff" : "#000",
                onClick: toggling
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownListContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownList, {
                    ref: dropdownRef,
                    children: options.map(function(option, index) {
                        return placeHolderText || index !== selectedOptionIndex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomListItem, {
                            onClick: onOptionClicked(index),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                children: option.label
                            })
                        }, option.label) : null;
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);
var CustomListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(ListItem).withConfig({
    componentId: "sc-7363816c-5"
})(_templateObject6());


/***/ }),

/***/ 94925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mybalance; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 20 modules
var src = __webpack_require__(23474);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 54 modules
var TextField = __webpack_require__(85975);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/AdapterDayjs/index.js + 1 modules
var AdapterDayjs = __webpack_require__(26829);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DesktopDatePicker/DesktopDatePicker.js + 93 modules
var DesktopDatePicker = __webpack_require__(10592);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js + 2 modules
var LocalizationProvider = __webpack_require__(52359);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var localization_src = __webpack_require__(68486);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(19237);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx
var Page = __webpack_require__(75915);
// EXTERNAL MODULE: ./src/components/Layout/PageHeader.tsx
var PageHeader = __webpack_require__(81904);
// EXTERNAL MODULE: ./src/components/Select/Select.tsx
var Select = __webpack_require__(76688);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Wallet.tsx
var Wallet = __webpack_require__(13385);
// EXTERNAL MODULE: ./src/config/api/decrypts.ts
var decrypts = __webpack_require__(43445);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/config/api/configHttp.ts
var configHttp = __webpack_require__(60102);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/auth/index.ts
var auth = __webpack_require__(57778);
// EXTERNAL MODULE: ./src/state/mybalance/actions.ts
var actions = __webpack_require__(58032);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./src/config/api/encrypt.ts
var encrypt = __webpack_require__(52048);
;// CONCATENATED MODULE: ./src/state/mybalance/fetchData.tsx






var fetchListTransactions = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(renderURL) {
        var token, hash, ref, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    token = (0,decrypts/* Decrypts */._O)();
                    hash = (0,encrypt/* HashClient */.L1)("balance/get-history");
                    return [
                        4,
                        (0,axios/* default */.Z)({
                            method: "GET",
                            url: renderURL,
                            headers: {
                                "Authorization": "Bearer ".concat(token),
                                "hash-client": "".concat(hash)
                            }
                        })
                    ];
                case 1:
                    ref = _state.sent(), response = ref.data;
                    return [
                        2,
                        {
                            listTransactions: response.data.data
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listTransactions: []
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchListTransactions(renderURL) {
        return _ref.apply(this, arguments);
    };
}();
var fetchUserBalance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var token, hash, ref, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    token = (0,decrypts/* Decrypts */._O)();
                    hash = (0,encrypt/* HashClient */.L1)("user/balance");
                    return [
                        4,
                        (0,axios/* default */.Z)({
                            method: "GET",
                            url: "".concat(configHttp/* URL */.J, "/user/balance"),
                            headers: {
                                "Authorization": "Bearer ".concat(token),
                                "hash-client": "".concat(hash)
                            }
                        })
                    ];
                case 1:
                    ref = _state.sent(), response = ref.data;
                    return [
                        2,
                        {
                            listBalance: {
                                mainBalance: response.data.data.filter(function(data) {
                                    return data.balance_type === 1;
                                }),
                                earnBalance: response.data.data.filter(function(data) {
                                    return data.balance_type === 2;
                                })
                            }
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2,
                        {
                            listBalance: {
                                mainBalance: 0,
                                earnBalance: 0
                            }
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchUserBalance() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/state/mybalance/index.tsx









var GetAllTransaction = function(start, end) {
    var mybalance = (0,es/* useSelector */.v9)(function(state) {
        return state.mybalance;
    });
    var listAllTransactions = mybalance.listTransactions;
    var ref = (0,_sliced_to_array/* default */.Z)((0,auth/* GetTokenUser */.f)(), 1), tokenByUser = ref[0];
    // eslint-disable-next-line no-console
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var getAllTransactions = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var renderURL, result, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            renderURL = start !== null && end !== null ? "".concat(configHttp/* URL */.J, "/balance/get-history?from=").concat(start, "&to=").concat(end) : "".concat(configHttp/* URL */.J, "/balance/get-history");
                            return [
                                4,
                                fetchListTransactions(renderURL)
                            ];
                        case 1:
                            result = _state.sent();
                            dispatch((0,actions/* fetchAllTransactions */.m)(result));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getAllTransactions() {
                return _ref.apply(this, arguments);
            };
        }();
        if (tokenByUser) {
            getAllTransactions();
        }
    }, [
        start,
        end,
        dispatch,
        tokenByUser
    ]);
    return [
        listAllTransactions
    ];
};
var GetListBalance = function() {
    var mybalance = (0,es/* useSelector */.v9)(function(state) {
        return state.mybalance;
    });
    var mainBalance = mybalance.listBanlace.mainBalance;
    var ref = (0,_sliced_to_array/* default */.Z)((0,auth/* GetTokenUser */.f)(), 1), tokenByUser = ref[0];
    var earnBalance = mybalance.listBanlace.earnBalance;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var getListBalance = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var result, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                fetchUserBalance()
                            ];
                        case 1:
                            result = _state.sent();
                            dispatch((0,actions/* fetchBalance */.E)(result));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log(e);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getListBalance() {
                return _ref.apply(this, arguments);
            };
        }();
        if (tokenByUser) {
            getListBalance();
        }
    }, [
        tokenByUser
    ]);
    return [
        mainBalance,
        earnBalance
    ];
};

;// CONCATENATED MODULE: ./src/views/MyBalance/components/CardOffChain.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-around;\n    align-items: center;\n    flex-direction:column;\n    height: 160px;\n    width:100%;\n    border-radius:12px;\n    background:",
        ";\n    padding:18px 22px 18px 22px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CardOffChain = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)(GetListBalance(), 2), mainBalance = ref[0], earnBalance = ref[1];
    var data = (0,decrypts/* DecryptsUserInfo */.hg)() || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardOffChain_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wallet/* default */.Z, {
                        filterColor: "#60E18D"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        fontSize: "18px",
                        ml: "10px",
                        color: "#fff",
                        children: "Off-chain"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "50%",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "18px",
                                bold: true,
                                color: "#fff",
                                children: "Main wallet"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        bold: true,
                                        color: "#fff",
                                        mr: "5px",
                                        children: data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: mainBalance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                bold: true,
                                                color: "#fff",
                                                children: "".concat(Number(mainBalance[0].balance).toLocaleString("en", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }))
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                bold: true,
                                                color: "#fff",
                                                children: "0.00"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#fff",
                                            children: t("No Data")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/tokens/0xc643E83587818202E0fFf5eD96D10Abbc8Bb48e7.png",
                                        alt: "logo runtogether",
                                        style: {
                                            width: "30px",
                                            height: "30px"
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "18px",
                                bold: true,
                                color: "#fff",
                                children: "Earn wallet"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        bold: true,
                                        color: "#fff",
                                        mr: "5px",
                                        children: data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: !earnBalance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                bold: true,
                                                color: "#fff",
                                                children: "0.00"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                bold: true,
                                                color: "#fff",
                                                children: "".concat(Number(earnBalance[0].balance).toLocaleString("en", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                }))
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "#fff",
                                            children: t("No Data")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/tokens/0xc643E83587818202E0fFf5eD96D10Abbc8Bb48e7.png",
                                        alt: "logo runtogether",
                                        style: {
                                            width: "30px",
                                            height: "30px"
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CardOffChain = (CardOffChain);
var CardOffChain_Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e950d42-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.success;
});

// EXTERNAL MODULE: ./src/utils/getTokenBalance.tsx
var getTokenBalance = __webpack_require__(69038);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var tokens_src = __webpack_require__(30693);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
;// CONCATENATED MODULE: ./src/views/MyBalance/components/CardOnChain.tsx

function CardOnChain_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: space-around;\n    align-items: center;\n    flex-direction:column;\n    height: 160px;\n    width:100%;\n    border-radius:12px;\n    background: ",
        "; \n    padding:18px 22px 18px 22px;\n"
    ]);
    CardOnChain_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var CardOnChain = function() {
    var renderTokenByChain = function renderTokenByChain(chainId) {
        if (chainId === src/* ChainId.BSC */.a_.BSC) {
            return tokens_src/* bscTokens.runtogether.address */.ds.runtogether.address;
        }
        if (chainId === src/* ChainId.ETHW_MAINNET */.a_.ETHW_MAINNET) {
            return tokens_src/* ethwTokens.runtogether.address */.U5.runtogether.address;
        }
        if (chainId === src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET) {
            return tokens_src/* bscTestnetTokens.runtogether.address */.dI.runtogether.address;
        }
        if (chainId === src/* ChainId.ONUS */.a_.ONUS) {
            return tokens_src/* onusMainnetTokens.runtogether.address */.Au.runtogether.address;
        }
        return "";
    };
    var ref = (0,useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var tokenAddress = renderTokenByChain(chainId);
    var balance = (0,getTokenBalance/* GetTokenBalance */.f)(tokenAddress, account, chainId).balance;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardOnChain_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wallet/* default */.Z, {
                        filterColor: "#F86F61"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        bold: true,
                        fontSize: "18px",
                        ml: "10px",
                        color: "#fff",
                        children: " On-chain"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "18px",
                        bold: true,
                        color: "#fff",
                        children: "On-wallet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        children: [
                            account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                color: "#fff",
                                mr: "10px",
                                children: Number(balance).toLocaleString("en", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "#fff",
                                mr: "10px",
                                children: t("No Data")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/tokens/0xc643E83587818202E0fFf5eD96D10Abbc8Bb48e7.png",
                                alt: "logo runtogether",
                                style: {
                                    width: "30px",
                                    height: "30px"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CardOnChain = (CardOnChain);
var CardOnChain_Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-cbeba12b-0"
})(CardOnChain_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.warning43;
});

// EXTERNAL MODULE: ./node_modules/react-paginate/dist/react-paginate.js
var react_paginate = __webpack_require__(11358);
var react_paginate_default = /*#__PURE__*/__webpack_require__.n(react_paginate);
;// CONCATENATED MODULE: ./src/views/MyBalance/config.ts
var config = function(t) {
    return [
        {
            label: t("All"),
            value: 0
        },
        {
            label: t("DEPOSIT"),
            value: 1
        },
        {
            label: t("WITHDRAWAL"),
            value: 2
        },
        {
            label: t("ORDER PLACED"),
            value: 3
        },
        {
            label: t("ORDER FILLED"),
            value: 4
        },
        {
            label: t("TRADE COMMISSION"),
            value: 5
        },
        {
            label: t("TAX COMMISSION"),
            value: 6
        },
        {
            label: t("LOAN COMMISSION"),
            value: 7
        },
        {
            label: t("LOSS CUT COMMISSION"),
            value: 8
        },
        {
            label: t("SWAP COMMISSION"),
            value: 9
        },
        {
            label: t("ORDER CANCELED"),
            value: 10
        },
        {
            label: t("WITHDRAWAL REJECT"),
            value: 11
        },
        {
            label: t("EARN"),
            value: 12
        },
        {
            label: t("REPAIR"),
            value: 13
        },
        {
            label: t("REFERRAL INVITE"),
            value: 14
        },
        {
            label: t("REFERRAL WITHDRAWAL"),
            value: 15
        },
        {
            label: t("REFERRAL EARN"),
            value: 16
        },
        {
            label: t("FEE TRANSFER SNEAKER"),
            value: 17
        },
        {
            label: t("BUY BOX"),
            value: 18
        },
        {
            label: t("NFC STEP EARN"),
            value: 19
        },
        {
            label: t("BUY SNEAKER"),
            value: 20
        },
        {
            label: t("BUY MARKET SNEAKER"),
            value: 21
        },
        {
            label: t("BUY MARKET BOX"),
            value: 22
        },
        {
            label: t("STAKING"),
            value: 23
        },
        {
            label: t("MINTING"),
            value: 24
        },
        {
            label: t("WITHDRAWAL EARN"),
            value: 25
        },
        {
            label: t("WITHDRAWAL STAKING"),
            value: 26
        },
        {
            label: t("COMMISSION WITHDRAWAL"),
            value: 27
        },
        {
            label: t("COMMISSION MINING"),
            value: 28
        }, 
    ];
};

;// CONCATENATED MODULE: ./src/views/MyBalance/components/Row.tsx

function Row_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height:100px;\n    padding-left:12px;\n    box-shadow: inset 0px -1px 0px #E4E4E4;\n    flex-wrap: wrap;\n    @media screen and (max-width: 600px) {\n        height:auto;\n        padding-top:20px;\n        padding-bottom:20px;\n        padding-left:12px;\n        padding-right:12px;\n    }\n"
    ]);
    Row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:190px;\n    min-width:120px;\n    height: 42px;\n    background: ",
        ";\n    border-radius: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color:#fff;\n    font-size:14px;\n    font-weight:500;\n    @media screen and (max-width: 600px) {\n        width:190px;\n        min-width:120px;\n        font-size:14px;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:15%;\n    height: 100%;\n    align-items: center;\n    padding-left: 1rem;\n    @media screen and (max-width: 600px) {\n        width:100%;\n        padding-left: 0rem;\n        height:50px;\n        justify-content: space-between;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:29%;\n    height: 100%;\n    align-items: center;\n    padding-left: 1rem;\n    @media screen and (max-width: 600px) {\n        width:100%;\n        height:50px;\n        padding-left: 0rem;\n        justify-content: space-between;\n    }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:31%;\n    height: 100%;\n    align-items: center;\n    padding-left: 1rem;\n    @media screen and (max-width: 600px) {\n        width:100%;\n        padding-left: 0rem;\n        height:50px;\n        justify-content: space-between;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:25%;\n    height: 100%;\n    align-items: center;\n    padding-left: 1rem;\n    @media screen and (max-width: 600px) {\n        width:100%;\n        padding-left: 0rem;\n        height:50px;\n        justify-content: space-between;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items:center;\n    width:120px;\n    @media screen and (max-width: 600px) {\n        width: auto !important;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n     @media screen and (min-width: 600px) {\n        display: none;\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}







var Row = function(param) {
    var typeTx = param.typeTx, time = param.time, balance = param.balance;
    var renderBgTag = function renderBgTag() {
        return "#45C672";
    };
    var converDate = function converDate(date) {
        var newDate = Date.parse(date);
        return new Date(newDate).toLocaleString("vi-VN", {
            timeZone: "Asia/Ho_Chi_Minh"
        });
    };
    var convertBalance = function convertBalance(balanceOfTx) {
        var converNumber = Number(balanceOfTx);
        if (converNumber >= 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mr: "10px",
                bold: true,
                children: "+".concat(converNumber.toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }))
            });
        }
        if (converNumber < 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mr: "10px",
                bold: true,
                children: "".concat(converNumber.toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }))
            });
        }
        return "";
    };
    var theme = (0,useTheme/* default */.ZP)().theme;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var reason = config(t).filter(function(data) {
        return data.value === typeTx;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerRow, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerChain, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerTitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                            children: "Chain"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                        children: "Off-chain"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerType, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerTitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                            children: "Type"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                        children: reason[0].label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerTime, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerTitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                            children: "Time"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: converDate(time)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerBalance, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerTitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsText, {
                            children: "Balance"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerUserBalance, {
                        children: [
                            convertBalance(balance),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/tokens/0xc643E83587818202E0fFf5eD96D10Abbc8Bb48e7.png",
                                alt: "logo runtogether",
                                style: {
                                    width: "30px",
                                    height: "30px"
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Row = (Row);
var ContainerRow = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-38e0bd56-0"
})(Row_templateObject());
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38e0bd56-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});
var ContainerChain = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-38e0bd56-2"
})(_templateObject2());
var ContainerType = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-38e0bd56-3"
})(_templateObject3());
var ContainerTime = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-38e0bd56-4"
})(_templateObject4());
var ContainerBalance = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-38e0bd56-5"
})(_templateObject5());
var ContainerUserBalance = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-38e0bd56-6"
})(_templateObject6());
var ContainerTitle = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-38e0bd56-7"
})(_templateObject7());
var CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-38e0bd56-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.black;
});

;// CONCATENATED MODULE: ./src/views/MyBalance/components/ContainerOffChain.tsx


function ContainerOffChain_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height:100px;\n    padding-left:12px;\n    box-shadow: inset 0px -1px 0px #E4E4E4;\n    flex-wrap: wrap;\n    @media screen and (max-width: 600px) {\n        display: none;\n    }\n    \n"
    ]);
    ContainerOffChain_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContainerOffChain_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 146px;\n    height: 42px;\n    background: ",
        ";\n    border-radius: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color:#fff;\n    @media screen and (max-width: 600px) {\n        width: 110px;\n        font-size:14px;\n    }\n"
    ]);
    ContainerOffChain_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContainerOffChain_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:15%;\n    height: 100%;\n    align-items: center;\n    padding-left: 1rem;\n    @media screen and (max-width: 600px) {\n        width:100%;\n        padding-left: 0rem;\n        height:50px;\n        justify-content: space-between;\n    }\n"
    ]);
    ContainerOffChain_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContainerOffChain_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:29%;\n    height: 100%;\n    align-items: center;\n    padding-left: 1rem;\n    @media screen and (max-width: 600px) {\n        width:100%;\n        height:50px;\n        padding-left: 0rem;\n        justify-content: space-between;\n    }\n"
    ]);
    ContainerOffChain_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContainerOffChain_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:31%;\n    height: 100%;\n    align-items: center;\n    padding-left: 1rem;\n    @media screen and (max-width: 600px) {\n        width:100%;\n        padding-left: 0rem;\n        height:50px;\n        justify-content: space-between;\n    }\n"
    ]);
    ContainerOffChain_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ContainerOffChain_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:25%;\n    height: 100%;\n    align-items: center;\n    padding-left: 1rem;\n    @media screen and (max-width: 600px) {\n        width:100%;\n        padding-left: 0rem;\n        height:50px;\n        justify-content: space-between;\n    }\n"
    ]);
    ContainerOffChain_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ContainerOffChain_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n     @media screen and (min-width: 600px) {\n        display: none;\n    }\n"
    ]);
    ContainerOffChain_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ContainerOffChain_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nmargin-bottom:1.5rem;\n.pagination{\n    display:flex;\n    flex-direction: row;\n    width:500px;\n    justify-content:space-around;\n    align-items:center;\n    @media screen and (max-width: 600px){\n        width: 100%;\n    }\n    *{\n        list-style-type: none;\n    }\n}\n.page-link {\n    background:",
        ";\n    padding:12px;\n    border-radius:5px !important;\n    border:none !important;\n    color:",
        ";\n    &:focus {\n        box-shadow:none !important;\n    }\n    &:hover{\n        background:",
        ";\n    }\n}\n.page-item.disabled .page-link{\n    background:",
        ";\n    cursor: not-allowed! important;\n    opacity: 0.7;\n    pointer-events:none;\n}\n.page-item.active .page-link{\n    background:",
        ";\n    color:#fff;\n}\n"
    ]);
    ContainerOffChain_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ContainerOffChain_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n"
    ]);
    ContainerOffChain_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}








var ContainerOnChain = function(param) {
    var filterTx = param.filterTx, startDate = param.startDate, endDate = param.endDate;
    var MovetoTop = // panigate
    function MovetoTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    };
    var itemsPerPage = 9;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(0), pageCount = ref[0], setPageCount = ref[1];
    var ref1 = (0,react.useState)(1), itemOffset = ref1[0], setItemOffset = ref1[1];
    var ref2 = (0,react.useState)([]), currentItems = ref2[0], setCurrentItems = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(GetAllTransaction(startDate, endDate), 1), listAllTransactions = ref3[0];
    var handlePageClick = function(event) {
        var newOffset = event.selected * itemsPerPage % listAllTransactions.length;
        setItemOffset(newOffset);
    };
    (0,react.useEffect)(function() {
        var endOffset = itemOffset + itemsPerPage;
        setCurrentItems(listAllTransactions.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(listAllTransactions.length / itemsPerPage));
    }, [
        itemOffset,
        itemsPerPage,
        listAllTransactions
    ]);
    (0,react.useEffect)(function() {
        setItemOffset(0);
    }, [
        listAllTransactions
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        width: "100%",
        flexDirection: "column",
        height: "auto",
        mb: "1.5rem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerOffChain_ContainerRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOffChain_ContainerChain, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOffChain_CsText, {
                            children: "Chain"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOffChain_ContainerType, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOffChain_CsText, {
                            children: "Type"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOffChain_ContainerTime, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOffChain_CsText, {
                            children: "Time"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOffChain_ContainerBalance, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOffChain_CsText, {
                            children: "Balance"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                flexDirection: "column",
                mt: "1rem",
                height: "100%",
                minHeight: "50vh",
                children: currentItems.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: currentItems.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Row, {
                            typeTx: item.reason,
                            time: item.updated_time,
                            balance: item.balance_change
                        });
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    justifyContent: "center",
                    mt: "1rem",
                    alignItems: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mt: "2rem",
                        children: t("No Data")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFlex, {
                width: "100%",
                mt: "1rem",
                justifyContent: "center",
                height: "62px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_paginate_default()), {
                    nextLabel: ">",
                    onPageChange: handlePageClick,
                    pageRangeDisplayed: 3,
                    marginPagesDisplayed: 2,
                    pageCount: pageCount,
                    previousLabel: "<",
                    pageClassName: "page-item",
                    pageLinkClassName: "page-link",
                    previousClassName: "page-item",
                    previousLinkClassName: "page-link",
                    nextClassName: "page-item",
                    nextLinkClassName: "page-link",
                    breakLabel: "...",
                    breakClassName: "page-item",
                    breakLinkClassName: "page-link",
                    containerClassName: "pagination",
                    activeClassName: "active",
                    renderOnZeroPageCount: null,
                    onClick: MovetoTop
                })
            })
        ]
    });
};
/* harmony default export */ var ContainerOffChain = (ContainerOnChain);
var ContainerOffChain_ContainerRow = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5852e863-0"
})(ContainerOffChain_templateObject());
var ContainerOffChain_Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5852e863-1"
})(ContainerOffChain_templateObject1(), function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});
var ContainerOffChain_ContainerChain = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5852e863-2"
})(ContainerOffChain_templateObject2());
var ContainerOffChain_ContainerType = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5852e863-3"
})(ContainerOffChain_templateObject3());
var ContainerOffChain_ContainerTime = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5852e863-4"
})(ContainerOffChain_templateObject4());
var ContainerOffChain_ContainerBalance = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5852e863-5"
})(ContainerOffChain_templateObject5());
var ContainerOffChain_ContainerTitle = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5852e863-6"
})(ContainerOffChain_templateObject6());
var CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5852e863-7"
})(ContainerOffChain_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primaryBright;
});
var ContainerOffChain_CsText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-5852e863-8"
})(ContainerOffChain_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.colors.black;
});

;// CONCATENATED MODULE: ./src/views/MyBalance/index.tsx



function MyBalance_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:100%;\n    height: auto;\n    @media only screen and (max-width: 768px) {\n        padding-left:10px;\n        padding-right: 10px;\n    }\n"
    ]);
    MyBalance_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyBalance_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 50%;\n    &:nth-child(1){\n        padding-right:.5rem;\n         @media (max-width:600px){\n            padding-right:0\n         }\n    }\n    &:nth-child(2){\n        padding-left:.5rem;\n        @media (max-width:600px){\n            padding-left:0;\n         }\n    }\n    @media only screen and (max-width: 600px) {\n        width: 100%;\n        margin-bottom:1rem;\n    }\n"
    ]);
    MyBalance_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MyBalance_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width:auto;\n    @media only screen and (min-width: 600px) and (max-width: 1080px) {\n        width: 50%;\n    }\n    @media only screen and (max-width: 600px) {\n        width: 100%;\n    }\n"
    ]);
    MyBalance_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MyBalance_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "        \n    cursor: pointer;      \n    height: 48px!important; \n    width: 280px!important;  \n    @media only screen and (max-width: 600px) {\n        width: 100%!important;\n    }       \n    > div {       \n        border-radius: 12px!important;\n        height:100%!important; \n        width: 100%!important; \n        border:1px solid rgb(230, 232, 236)!important; \n        position: relative;\n        box-sizing:border-box;\n    }\n    @media only screen and (max-width: 600px) {\n        width: 100%;\n    }\n"
    ]);
    MyBalance_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MyBalance_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n    // width="100%" flexWrap="wrap" justifyContent="space-around" mt="1.5rem" padding=\'0px 70px 0px 70px\'\n    width: 100%;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    margin-top: 1.5rem;\n    padding: 0px 70px 0px 70px;\n    @media only screen and (max-width: 1024px) {\n        justify-content: space-between;\n        padding: 0px 0px 0px 0px;\n    }\n'
    ]);
    MyBalance_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

















function getDateNow(event) {
    var today;
    if (event) {
        today = new Date(event);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        today = "".concat(yyyy, "-").concat(mm, "-").concat(dd);
    } else {
        today = new Date();
        var dd1 = String(today.getDate()).padStart(2, "0");
        var mm1 = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy1 = today.getFullYear();
        today = "".concat(yyyy1, "-").concat(mm1, "-").concat(dd1);
    }
    return today;
}
var onKeyDown = function(e) {
    e.preventDefault();
};
var MyBalance = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,react.useState)(getDateNow(null)), startDate = ref[0], setStartDate = ref[1];
    var ref1 = (0,react.useState)(getDateNow(null)), endDate = ref1[0], setEndDate = ref1[1];
    var toastError = (0,useToast/* useToast */.p)().toastError;
    var ref2 = (0,react.useState)(false), isOnChain = ref2[0], setIsOnChain = ref2[1];
    var handleStartDate = function(event) {
        var start = getDateNow(event);
        var d1 = Date.parse(start);
        var d2 = Date.parse(endDate);
        if (d1 > d2) {
            toastError("The start date cannot be greater than the end date. Please try again");
            setStartDate(getDateNow());
            setEndDate(getDateNow());
            return;
        }
        if (start > getDateNow()) {
            toastError("The start date cannot be greater than the current date. Please try again");
            setStartDate(getDateNow());
            return;
        }
        setStartDate(start);
    };
    var handleEndDate = function(event) {
        var end = getDateNow(event);
        var d1 = Date.parse(startDate);
        var d2 = Date.parse(end);
        if (d1 > d2) {
            toastError("The end date must be greater than the start date. Please try again");
            setEndDate(getDateNow());
            return;
        }
        if (end > getDateNow()) {
            toastError("The end date cannot be greater than the current date. Please try again");
            setEndDate(getDateNow());
            return;
        }
        setEndDate(end);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                nameTitle: "RUN TOGETHER",
                namePlace: "My balance",
                imgIcon: "/images/runMyBalance/imgBanner.png",
                bgColor: theme.colors.ogrange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            width: "100%",
                            flexWrap: "wrap",
                            mt: "1rem",
                            mb: "2.25rem",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerCard, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CardOnChain, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerCard, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CardOffChain, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyBalance_CustomFlex, {
                                    flexDirection: "column",
                                    mb: "1rem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            mb: "5px",
                                            color: "#B1B5C4",
                                            textTransform: "uppercase",
                                            children: t("Chain")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                            options: [
                                                {
                                                    label: t("Off-chain"),
                                                    value: false
                                                }
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyBalance_CustomFlex, {
                                    flexDirection: "column",
                                    mb: "1rem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            mb: "5px",
                                            color: "#B1B5C4",
                                            textTransform: "uppercase",
                                            children: t("Start date")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                                            dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCalendar, {
                                                // label="Date desktop"
                                                inputFormat: "DD/MM/YYYY",
                                                value: startDate,
                                                onChange: handleStartDate,
                                                renderInput: function(params) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                                        onKeyDown: onKeyDown
                                                    }));
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyBalance_CustomFlex, {
                                    flexDirection: "column",
                                    mb: "1rem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            mb: "5px",
                                            color: "#B1B5C4",
                                            textTransform: "uppercase",
                                            children: t("End date")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                                            dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCalendar, {
                                                // label="Date desktop"
                                                inputFormat: "DD/MM/YYYY",
                                                value: endDate,
                                                onChange: handleEndDate,
                                                renderInput: function(params) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                                                        onKeyDown: onKeyDown
                                                    }));
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            width: "100%",
                            mt: "1rem",
                            height: "fit-content",
                            children: isOnChain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "center",
                                mt: "1rem",
                                height: "100%",
                                minHeight: "50vh",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: t("No Data")
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerOffChain, {
                                startDate: startDate,
                                endDate: endDate
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var views_MyBalance = (MyBalance);
var CustomContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-72d6fd4f-0"
})(MyBalance_templateObject());
var ContainerCard = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-72d6fd4f-1"
})(MyBalance_templateObject1());
var MyBalance_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-72d6fd4f-2"
})(MyBalance_templateObject2());
var CustomCalendar = (0,styled_components_browser_esm/* default */.ZP)(DesktopDatePicker/* DesktopDatePicker */.$).withConfig({
    componentId: "sc-72d6fd4f-3"
})(MyBalance_templateObject3());
var CsContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-72d6fd4f-4"
})(MyBalance_templateObject4());

;// CONCATENATED MODULE: ./src/pages/mybalance.tsx



var MyBalancePage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(views_MyBalance, {});
};
MyBalancePage.chains = [
    src/* ChainId.BSC */.a_.BSC,
    src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET,
    src/* ChainId.ONUS */.a_.ONUS,
    src/* ChainId.ETHW_MAINNET */.a_.ETHW_MAINNET
];
/* harmony default export */ var mybalance = (MyBalancePage);


/***/ }),

/***/ 69038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ GetTokenBalance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70794);
/* harmony import */ var config_abi_erc20__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56309);
/* harmony import */ var utils_multicall__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9796);







var GetTokenBalance = function(tokenAddress, account, chainId) {
    var requested = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("0"), balance = ref[0], setBalance = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var getBalance = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                var calls, ref, resultBalance, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            calls = [
                                {
                                    address: tokenAddress,
                                    name: "balanceOf",
                                    params: [
                                        account
                                    ]
                                }
                            ];
                            return [
                                4,
                                (0,utils_multicall__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(config_abi_erc20__WEBPACK_IMPORTED_MODULE_2__/* .ERC20_ABI */ .RB, calls, chainId)
                            ];
                        case 1:
                            ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"].apply */ .Z.apply(void 0, [
                                _state.sent(),
                                1
                            ]), resultBalance = ref[0];
                            setBalance(new bignumber_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z(resultBalance).dividedBy(1E18).toString());
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            console.log(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getBalance() {
                return _ref.apply(this, arguments);
            };
        }();
        if (account !== undefined && tokenAddress.length) {
            getBalance();
        }
    }, [
        account,
        tokenAddress,
        chainId,
        requested
    ]);
    return {
        balance: balance
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1913,9774,2888,179], function() { return __webpack_exec__(91249); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);